import React from 'react';
import { Link } from 'react-router-dom';
import { useBlog } from '../../context/BlogContext';

function calculateReadingTime(post) {
  let wordCount = 0;
  if (post.blocks) {
    post.blocks.forEach(block => {
      if (block.type === 'text' && block.data) {
        if (block.data.heading) wordCount += block.data.heading.split(/\s+/).length;
        if (block.data.body) wordCount += block.data.body.split(/\s+/).length;
      }
      if (block.type === 'pullquote' && block.data?.quote) {
        wordCount += block.data.quote.split(/\s+/).length;
      }
      // Secciones importadas de WordPress
      if (block.type === 'wp_section' && block.data?.columns) {
        block.data.columns.flat().forEach(item => {
          const text = item.text || (item.html ? item.html.replace(/<[^>]+>/g, ' ') : '');
          if (text.trim()) wordCount += text.trim().split(/\s+/).length;
        });
      }
    });
  }
  const minutes = Math.max(1, Math.ceil(wordCount / 200));
  return `${minutes} min`;
}

export default function BlogCard({ post, featured = false }) {
  const { categories } = useBlog();
  // Nombre real de la categoría (con acentos); si no existe, el slug legible.
  const categoryName =
    categories?.find(c => c.slug === post.category)?.name ||
    (post.category || '').replace(/-/g, ' ');
  const categoryLabel = categoryName
    ? categoryName.charAt(0).toUpperCase() + categoryName.slice(1)
    : '';

  const readingTime = calculateReadingTime(post);

  return (
    <Link
      to={`/journal/${post.slug}`}
      className={`blog-card ${featured ? 'blog-card--featured' : 'blog-card--image'}`}
    >
      <div className="blog-card-img-wrapper">
        <img src={post.thumbnail} alt={post.title} className="blog-card-img" />
      </div>
      <div className="blog-card-content">
        <span className="blog-card-category">{categoryLabel}</span>
        <h3 className="blog-card-title">{post.title}</h3>
        <p className="blog-card-excerpt">{post.excerpt}</p>
        <span className="blog-card-reading-time">Tiempo de lectura: {readingTime}</span>
        <span className="blog-card-line" />
        <span className="blog-card-link">Leer más</span>
      </div>
    </Link>
  );
}

export { calculateReadingTime };
